<template>
<v-simple-table dense>
<!--  {{customersWaiting}}-->
<!--  {{samplesProcessing}}-->
  <thead>
    <tr>
      <th>
        <v-btn color="secondary" @click="$store.dispatch('ReleaseSampleStore/releaseSomeSamples', filteredSamples.map(sample => sample.uuid))" tile small block>Release All</v-btn>
      </th>
      <th>ID</th>
      <th style="width: 1%; white-space:nowrap">Invoice ID</th>
      <th>Required Tests</th>
      <th>Billing Approved</th>
      <th>Notes/Flags</th>
      <th>Name</th>
      <th>Type</th>
      <th>QA</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="sample in filteredSamples" :key="sample.uuid">
      <td style="width: 1%; white-space:nowrap">
<!--        <ReleaseSample :sample="sample" @update_sample="$emit('update_sample', {...$event, uuid: sample.uuid})"></ReleaseSample>-->
        <ReleaseSampleV2 :sample="sample"></ReleaseSampleV2>
      </td>
      <td style="width: 1%; white-space:nowrap">{{sample.id}}</td>
      <td style="width: 1%; white-space:nowrap">{{sample.meta_data && sample.meta_data.invoice_id ? sample.meta_data.invoice_id : 'N/A'}}</td>
      <td style="width: 1%; white-space:nowrap">
        <RequiredTests :sample="sample" chips></RequiredTests>
      </td>
      <td style="width: 1%; white-space:nowrap">
        {{sample.billing_approved ? "Yes" : "No"}}
      </td>
      <td style="width: 1%; max-width: 250px;">
        <v-tooltip color="grey darken-3" bottom>
          <template v-slot:activator="{on}">
            <v-chip v-on="on" color="primary" class="white--text pa-1"  small label>{{sample.sample_notes.length}} notes</v-chip>
          </template>
          <template v-if="sample.sample_notes.length > 0" v-for="(note, index) in sample.sample_notes">
            <span :key="note.uuid">({{note.note_type.name}}) - {{note.note}}</span>
            <v-divider class="grey" :key="index"></v-divider>
          </template>
          <span v-else>No Notes</span>
        </v-tooltip>
        <template v-if="sample.sample_flags.length > 0">
          <v-tooltip v-for="flag in sample.sample_flags" :key="flag.uuid" color="grey darken-3" bottom>
            <template v-slot:activator="{on}">
              <v-chip v-on="on" :color="flag.flag_type.color" class="white--text pa-1"  small label>
                <span v-if="flag.flag_type.name.split(' ').length > 1">{{flag.flag_type.name.split(' ').map(text => text[0]).join('')}}</span>
                <span v-else>{{flag.flag_type.name.substring(0,3)}}</span>
              </v-chip>
            </template>
            <span>{{flag.flag_type.name}}</span>
          </v-tooltip>
        </template>
      </td>
      <td>
        {{sample.name}}
      </td>
      <td>
        {{sample.sample_cert_type.name}}
      </td>
      <td>
        {{sample.qa}}
      </td>
    </tr>
  </tbody>
</v-simple-table>
</template>

<script>
export default {
    name: "CustomerSamplesTable",
    components: {
      RequiredTests: () => import("@/components/general/samples/RequiredTests"),
      ReleaseSample: () => import("./ReleaseSample"),
      ReleaseSampleV2: () => import("./ReleaseSampleV2")
    },
    data: () => ({}),
    props: {
      // customer_info:{
      //   required: false,
      // },
      samples: {
        required: true,
      },
      search: {
        default: null,
        required: false,
      }
    },
    computed:{
      filteredSamples(){
        if(this.search){
          const search = this.search.toLowerCase();
          return this.samples.filter(sample => {
            let searchable = JSON.stringify(sample).toLowerCase();
            return searchable.includes(search);
          })
        }
        return this.samples;
      },
      samplesProcessing(){
        const sample_uuids = Object.keys(this.$store.state.ReleaseSampleStore.samplesProcessing)
        return this.samples.some(sample => {
          return sample_uuids.includes(sample.uuid)
        })
      },
      customersWaiting(){
        return this.$store.state.ReleaseSampleStore.customersWaitingForRelease
      }
    },
    watch: {
      samplesProcessing(v){
        this.updateCustomersWaiting(v);
      }
    },
    mounted(){
      this.updateCustomersWaiting(this.samplesProcessing);
    },

    methods: {
      updateCustomersWaiting(v){
        if(v && !this.$store.state.ReleaseSampleStore.customersWaitingForRelease.hasOwnProperty(this.samples[0].customer_id)){
          this.$set(this.$store.state.ReleaseSampleStore.customersWaitingForRelease, this.samples[0].customer_id, true)
        }else{
          this.$delete(this.$store.state.ReleaseSampleStore.customersWaitingForRelease, this.samples[0].customer_id)
        }
      },
    }
}
</script>

<style scoped>

</style>
